module.exports = __webpack_public_path__ + "img/bar-chart.ed56df09.svg";